<template>
    <div>
      <compra-direta-ferramenta-de-busca v-model="filtrosBuscaAvancada"
                                         :situacoesPossiveis="situacoesPossiveisFornecedor"
                                         :placeholderPesquisa="placeholderPesquisa"
                                         :filtros="filtrosInterno"
                                         @eventoBuscaSimples="tratarEventoBuscaSimples"
                                         @eventoRemoverFiltro="tratarEventoRemoverFiltro"
                                         @eventoBuscaAvancada="processarEventoBuscarAvancada"
                                         @updateSituacoes="(situacoes) => filtrosBuscaAvancada.situacoes = situacoes">
      </compra-direta-ferramenta-de-busca>

      <compras-diretas-meu-interesse-carrossel v-model="comprasDiretasMeuInteresse"
                                               v-if="comprasDiretasMeuInteresse.length > 0"
                                               :paginas="paginasMeuInteresse"
                                               :total-itens="totalItensMeuInteresse"
                                               :paginacao="$store.state.fornecedor.resultadoBuscaMeuInteresseComprasDiretas.paginacao"
                                               @paginar="tratarEventoPaginarMeuInteresse"/>

        <compras-diretas-disponiveis-tabela :itens="itens"
                                            :paginas="paginas"
                                            :total-itens="totalItens"
                                            :paginacao="$store.state.fornecedor.resultadoBuscaComprasDiretasDisponiveis.paginacao"
                                            @acessarPncp="acessarPncp"
                                            @paginar="tratarEventoPaginar"
                                            @acessar="tratarEventoAcessar"
                                            @acessarDocumentoProposta="acessarDocumentoProposta"/>
    </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes, mutationTypes} from '@/core/constants'
import ComprasDiretasDisponiveisTabela from './ComprasDiretasDisponiveisTabela'
import ComprasDiretasMeuInteresseCarrossel from '@/views/pages/fornecedor/compras-diretas-abertas/ComprasDiretasMeuInteresseCarrossel'
import CompraDiretaFerramentaDeBusca from '@/views/pages/commons/busca-avancada/CompraDiretaFerramentaDeBusca'

export default {
    name: 'TodasComprasDiretas',
    components: {
        CompraDiretaFerramentaDeBusca,
        ComprasDiretasMeuInteresseCarrossel,
        ComprasDiretasDisponiveisTabela
    },
    data() {
        return {
            filtrosInterno: this.getFiltrosFornecedor(),
            filtrosBuscaAvancada: this.getFiltrosBuscaAvancadaFornecedor(),
            itens: [],
            itensMinhasComprasDiretasAbertas: [],
            comprasDiretasMeuInteresse:[],
            paginasMeuInteresse: 0,
            totalItensMeuInteresse: 0,
            paginas: 0,
            totalItens: 0,
            idItemParaDeletar: null,
            ehBuscaAvancada: false
        }
    },
    computed: {
        placeholderPesquisa() {
            const texto = this.$t('main.fornecedor_compras_diretas_disponiveis_orgao.text').toLowerCase()
            return `Busque por: nº processo, nº consulta, objeto ou ${texto}`
        },
        situacoesPossiveisFornecedor(){
            const situacoesPossiveis = { ...this.situacoesCompraDireta }

            delete situacoesPossiveis['EM_ELABORACAO']

            return situacoesPossiveis
        }
    },
    async mounted() {
        try {
            await this.buscarComprasDiretasMeuinteresse()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarComprasDiretasMeuinteresse() {
            this.$store.commit(mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_MEU_INTERESSE_COMPRAS_DIRETAS, this.getFiltrosFornecedorMeuInteresse())

            const resultado = await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_COMPRAS_DIRETAS_MEU_INTERESSE)
            this.comprasDiretasMeuInteresse = resultado.itemList
            this.paginasMeuInteresse = resultado.totalPages
            this.totalItensMeuInteresse = resultado.totalElements
        },
        tratarEventoPaginarMeuInteresse(paginacao) {
            this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_MEU_INTERESSE_COMPRAS_DIRETAS, paginacao)
            this.buscarComprasDiretasMeuinteresse()
        },
        async buscarComprasDiretasDisponiveis() {
            this.$store.commit(mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_COMPRAS_DIRETAS_DISPONIVEIS, this.getFiltrosInterno())
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_COMPRAS_DIRETAS_DISPONIVEIS)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.resetFiltroBuscaAvancadaFornecedor()
        },
        tratarEventoPaginar(paginacao) {
            if(this.ehBuscaAvancada){
                this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR, paginacao)
                this.processarEventoBuscarAvancada()
            }
            else{
                this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_COMPRAS_DIRETAS_DISPONIVEIS, paginacao)
                this.buscarComprasDiretasDisponiveis()
            }
        },
        tratarEventoBuscaSimples(valor) {
            if (valor) {
                this.filtrosInterno.conteudo = valor
                this.filtrosInterno.objeto.value = valor
                this.buscarComprasDiretasDisponiveis()
            }
        },
        tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.filtrosInterno.conteudo = ''
            this.resetFiltroBuscaAvancadaFornecedor()
            this.filtrosBuscaAvancada = this.getFiltrosBuscaAvancadaFornecedor()
            this.buscarComprasDiretasDisponiveis()
        },
        tratarEventoAcessar(id) {
            this.$store.commit(mutationTypes.SET_ROTA_ORIGEM, 'ComprasDiretasAbertas')
            this.$router.push({name: 'DetalhesCompraDireta', params: {id}})
        },
        getFiltrosFornecedor() {
            return _.cloneDeep(this.$store.state.fornecedor.resultadoBuscaComprasDiretasDisponiveis.filtros)
        },
        getFiltrosFornecedorMeuInteresse() {
            return _.cloneDeep(this.$store.state.fornecedor.resultadoBuscaMeuInteresseComprasDiretas.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        async acessarPncp({cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp}) {
            await this.$store.dispatch(actionTypes.EXIBIR_NO_PNCP, {cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp})
        },
        acessarDocumentoProposta(compra) {
            this.$store.commit(mutationTypes.SET_ROTA_ORIGEM, 'ComprasDiretasAbertas')
            this.$router.push({path: `compra-direta/${compra.id}/resultado/${compra.propostaId}/documento-proposta`})
        },
        getFiltrosBuscaAvancadaFornecedor() {
            return _.cloneDeep(this.$store.state.fornecedor.resultadoBuscaAvancadaComprasDiretasFornecedor.filtros)
        },
        resetFiltroBuscaAvancadaFornecedor(){
            this.ehBuscaAvancada = false
            this.$store.state.fornecedor.resultadoBuscaAvancadaComprasDiretasFornecedor.reset()

            /**
             * TODO Refatorar o funcionamento da busca avançada para se usar o esquema da busca simples
             *  e depois remove essas linhas abaixo, e também o atributo ehBuscaAvancada
             */

            const paginacaoInicial = {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            }
            this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_COMPRAS_DIRETAS_DISPONIVEIS, paginacaoInicial)
            this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR, paginacaoInicial)
        },
        async processarEventoBuscarAvancada() {
            this.$store.commit(mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR, this.filtrosBuscaAvancada)
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.ehBuscaAvancada = true
        },
    }
}
</script>
